
<template>
 <div>
  <!-- ClientFile Layout -->
  <router-view/>
  
 </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClientFileLayout extends Vue {
}
</script>

